module.exports = __webpack_public_path__ + "img/042.f500194e.jpg";